import { RootState } from '../store';

export const selectOmeApplications = (state: RootState) => state.omeApplication.applications;
export const selectOmeApplicationsLoaded = (state: RootState) => state.omeApplication.loaded;
export const selectOmeApplyInProgress = (state: RootState) => state.omeApplication.applyInProgress;
